import Menu from "../components/general/Menu"
import Footer from "../components/general/Footer"
import { Container, Col, Row } from "react-bootstrap"
import Header from "components/Profile/Header"
import { default as ProfileMenu } from "components/Profile/Menu"
import { useSelector } from "react-redux"
import NotAuthorized from "./NotAuthorized"
import { createContext, useEffect, useState, useCallback } from "react"
import { useParams } from 'react-router-dom'

export const ProfileContext = createContext()

export default function Profile() {

  const { user: authUser } = useSelector(x => x.auth)
  const url = process.env.REACT_APP_URL
  const params = useParams()
  const userId = params.userId
  const effectiveUserId = String(userId || authUser?.user?._id || authUser?._id || '').trim()


  // console.log(userId)

  const [profile, setProfile] = useState([])
  const [users, setUsers] = useState([])
  // Fetch all users on load
  useEffect(() => {
    const fetchUsers = async () => {
      if (!authUser) return;
      try {
        const response = await fetch(`${url}/users/`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authUser.token}`,
          },
        });
        if (!response.ok) throw new Error('Failed to fetch users');
        const data = await response.json();
        setUsers(data);
      } catch (e) {
        setUsers([]);
      }
    };
    fetchUsers();
  }, [authUser, url]);

  const getProfile = useCallback(async () => {

    if (!authUser) return

    if (!effectiveUserId) return

    try {
      const res = await fetch(`${url}/users/${effectiveUserId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + authUser.token
        },
      })

      if (res.status !== 200 && res.status !== 201) {
        throw new Error('(' + res.status + ') We could not retrieve the user')
      }

      const resData = await res.json()
      setProfile(resData)
    } catch (error) {
      console.error('Error fetching profile:', error)
    }
  }, [url, effectiveUserId, authUser]
  )

  useEffect(() => {
    if (authUser) {
      getProfile()
    }
  }, [getProfile, authUser])

  if (!authUser) {
    return <NotAuthorized />
  }
  else {
    return (
      <ProfileContext.Provider value={{ profile, setProfile, getProfile, users }}>
        <>
          <Menu />
          <section className="main profile-page">
            <Container fluid className="px-3 px-md-4 profile-page-container">
              <Row className="profile-page-row">
                <Col className="profile-page-col">
                  <Header />
                  <div className="profile-page-scroll">
                    <ProfileMenu />
                  </div>

                </Col>
              </Row>
            </Container>
            <Footer />
          </section>
        </>
      </ProfileContext.Provider>
    )
  }
}